import React, { Fragment, useEffect, useState } from "react";
import { ActivityWrapper } from "./ActivitiesStyle";
import { AiOutlineCheckCircle, AiOutlineEdit } from "react-icons/ai";
import { IoIosRemoveCircleOutline } from "react-icons/io";
import { BsThreeDots } from "react-icons/bs";
import { BiCheckDouble } from "react-icons/bi";
import Typogaphy from "../Typography/Typography";
import { Collapce } from "../Collapce/Collapce";
import { EditActionModal } from "../Dialog/EditActionModal";
import { ActionNoteDoneModal } from "../Dialog/ActionNotDoneModal";
import { DeleteActionModal } from "../Dialog/DeleteActionModal";
import { Collapse } from "react-bootstrap";
import Button from "../Button/Button";
import { SwitchingActionModal } from "../Dialog/SwitchingActionModal";
import Converter from "persian-date-converter";
import { useActionComments, useAddComment } from "../../hooks/useCrm";
import { SimpleTextArea } from "../SimpleTextArea/SimpleTextArea";
import { MiladiToShamsi } from "../../utils/Miladi_To_Shamsi";
const initmodalvalue = {
  edit: false,
  actiondone: false,
  actionNotDone: false,
  SwitchingAction: false,
  actiondelete: false,
};
const initvalue = {
  IdS0alesOpportunities: null,
  IdActivityCrm: null,
  TextCommentForActivities: "",
};
export const Activities = ({ userdata }) => {
  const [show, setShow] = useState(initmodalvalue);
  const [open, setOpen] = useState(null);
  const [form, setForm] = useState(initvalue);
  const [editActionData, setEditActionData] = useState();
  const [activityId, setActivityId] = useState();
  const { data: ActionComments } = useActionComments({
    IdActivityCrm: activityId,
  });
  useEffect(() => {
    if (userdata) {
      setForm({
        ...form,
        IdS0alesOpportunities:
          userdata?.sales_opportunities[0]?.IdS0alesOpportunities,
      });
    }
  }, [userdata]);
  const { mutateAsync: AddComment, isLoading: AddingComment } = useAddComment();
  const handleAddComment = async (comment) => {
    await AddComment(comment).then(() =>
      setForm({ ...form, TextCommentForActivities: "" })
    );
  };
  const comments = ActionComments?.data?.comment_for_activities;
  const data = userdata;
  const _date = new Converter();
  const handleToggle = (id) => {
    if (!open || id !== open) {
      setOpen(id);
    } else if (open === id) {
      setOpen(false);
    }
  };
  return (
    <ActivityWrapper>
      <div className="row">
        <div className="col-12"></div>
      </div>
      <div className="actions row mb-4">
        {data?.Answeractivity_crms.map((action, index) => {
          return (
            <Fragment key={index}>
              <div className="img-holder col-lg-1 col-md-1 col-sm-2 col-2 mb-2 d-flex justify-content-center">
                <img
                  src={`https://apisedna.mahanskinclinic.com/thumbnail/Profile/${action.Image}`}
                  alt=""
                  className="img-fluid rounded-circle"
                />
              </div>
              <div className="card-holder col-lg-11 col-md-11 col-sm-10 col-10 mb-2">
                <div className="card-">
                  <div className="part-1 d-flex">
                    <div className="flex-fill">
                      <div className="d-flex">
                        <AiOutlineCheckCircle className="checkmark" />

                        {action.StatusImportant === "important" ? (
                          <>
                            <Typogaphy
                              size="14px"
                              weight="bold"
                              primary="#f1416c !important"
                              className="text-wrap"
                            >
                              {action.SubjectActivityCrm}
                            </Typogaphy>
                          </>
                        ) : (
                          <>
                            <Typogaphy
                              size="14px"
                              weight="bold"
                              className="text-wrap"
                            >
                              {action.SubjectActivityCrm}
                            </Typogaphy>
                          </>
                        )}
                      </div>
                      <Typogaphy className="description mt-2 mx-2 text-break">
                        {action.DescriptionActivityCrm}
                      </Typogaphy>
                      <div className="d-flex justify-content-between">
                        <Typogaphy className="mx-2 mt-3 recorddate" size="12px">
                          ثبت شده توسط{" "}
                          {action.FirstName + " " + action.LastName}{" "}
                          {MiladiToShamsi(action.created_at)}
                        </Typogaphy>
                        <Typogaphy
                          className="mx-2 mt-3 recorddate"
                          size="12px"
                          hover={"cursor:pointer"}
                          onClick={() => {
                            handleToggle(index);
                            setActivityId(action.IdActivityCrm);
                            setForm({
                              ...form,
                              IdActivityCrm: action.IdActivityCrm,
                            });
                          }}
                        >
                          لیست نظرات
                        </Typogaphy>
                      </div>
                    </div>

                    <div className="actions">
                      <Collapce title={<BsThreeDots className="threedots" />}>
                        <div className="collapse-content">
                          <div className="collapse-item d-flex">
                            <AiOutlineEdit />
                            <Typogaphy
                              onClick={() => {
                                setShow({ ...initmodalvalue, edit: true });
                                setEditActionData(action);
                              }}
                              hover={"cursor:pointer;"}
                            >
                              ویرایش
                            </Typogaphy>
                          </div>

                          <div className="collapse-item d-flex">
                            <AiOutlineCheckCircle className="action-not-done" />
                            <Typogaphy
                              onClick={() => {
                                setShow({
                                  ...initmodalvalue,
                                  actionNotDone: true,
                                });
                                setActivityId(action.IdActivityCrm);
                              }}
                              hover={"cursor:pointer"}
                            >
                              تبدیل به انجام نشده
                            </Typogaphy>
                          </div>
                          <div className="collapse-item d-flex">
                            <BiCheckDouble className="action-to-important action-done" />
                            <Typogaphy
                              onClick={() => {
                                setShow({
                                  ...initmodalvalue,
                                  SwitchingAction: true,
                                });
                                setActivityId(action.IdActivityCrm);
                              }}
                              hover={"cursor:pointer"}
                            >
                              تبدیل وضعیت فعالیت
                            </Typogaphy>
                          </div>

                          <div className="collapse-item d-flex">
                            <IoIosRemoveCircleOutline className="action-to-important action-not-done" />
                            <Typogaphy
                              onClick={() => {
                                setShow({
                                  ...initmodalvalue,
                                  actiondelete: true,
                                });
                                setActivityId(action.IdActivityCrm);
                              }}
                              hover={"cursor:pointer"}
                            >
                              حذف فعالیت
                            </Typogaphy>
                          </div>
                        </div>
                      </Collapce>
                    </div>
                  </div>
                  <div className="part-2">
                    <div className="w-100">
                      <Typogaphy className="action-answer">
                        {action.AnswerActivityCrm}
                      </Typogaphy>

                      {data?.AnswerLastName?.map((name, index) => (
                        <Fragment key={index}>
                          {name.IdActivityCrm === action.IdActivityCrm ? (
                            <Typogaphy
                              className="answer-record mx-2"
                              size="12px"
                            >
                              ثبت شده توسط {name.FirstName} {name.LastName}{" "}
                              {MiladiToShamsi(action.updated_at)}
                            </Typogaphy>
                          ) : null}
                        </Fragment>
                      ))}
                    </div>
                  </div>
                  <div className="part-3">
                    <Collapse in={open === index}>
                      <div className="w-100" id="example-collapse-text">
                        {comments?.map((comment, index) => {
                          var dateWrapper = _date.convert(
                            comment.created_at,
                            "fa"
                          );
                          return (
                            <div className="comment-item row" key={index}>
                              <div className="img-holder col-lg-1 col-2 d-flex justify-content-center">
                                <img
                                  src={`https://apisedna.mahanskinclinic.com/thumbnail/Profile/${comment.Image}`}
                                  alt=""
                                  className="rounded-circle"
                                />
                              </div>
                              <div className="content-holder col-10 col-lg-11 text-break">
                                <Typogaphy
                                  size="12px"
                                  className="comment-record-date"
                                >
                                  {comment.FirstName} {comment.LastName}
                                  {"  "}
                                  {dateWrapper}
                                </Typogaphy>
                                <Typogaphy size={"12px"}>
                                  {comment.TextCommentForActivities}
                                </Typogaphy>
                              </div>
                            </div>
                          );
                        })}

                        <div className="add-comment">
                          <div className="content-holder row m-1">
                            <div className="col-8 m-0 p-0">
                              <SimpleTextArea
                                cols="10"
                                rows="3"
                                placeholder="سید محمد یوسف جان اگر نظری داری اینجا بنویس"
                                onChange={(e) =>
                                  setForm({
                                    ...form,
                                    TextCommentForActivities: e.target.value,
                                  })
                                }
                                value={form.TextCommentForActivities}
                              />
                            </div>
                            <div className="col-4">
                              <Button
                                type="text"
                                bgColor="#50cd89"
                                color="#fff"
                                onclick={() => handleAddComment(form)}
                                size="12px"
                              >
                                {AddingComment ? "در حال ثبت" : "ثبت نظر"}
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Collapse>
                  </div>
                </div>
              </div>
            </Fragment>
          );
        })}
      </div>
      <EditActionModal
        handleClose={() => setShow({ ...initmodalvalue, edit: false })}
        show={show.edit}
        editActionData={editActionData}
      />

      <ActionNoteDoneModal
        handleClose={() => setShow({ ...initmodalvalue, actionNotDone: false })}
        show={show.actionNotDone}
        activityId={activityId}
      />
      <SwitchingActionModal
        handleClose={() =>
          setShow({ ...initmodalvalue, SwitchingAction: false })
        }
        show={show.SwitchingAction}
        activityId={activityId}
      />
      <DeleteActionModal
        handleClose={() => setShow({ ...initmodalvalue, actiondelete: false })}
        show={show.actiondelete}
        activityId={activityId}
      />
    </ActivityWrapper>
  );
};
